/* DaniChou – Kategorie- und Produktseite (Relaunch 10/2026)
   1. Lieferzeitraum auf der Produktseite ([data-dc-dlv-date]): heute + 2 bis 4 Werktage (ohne Sa/So und bundesweite Feiertage)
   2. Kategorieseite: ausverkaufte Produkte ans Ende des Rasters (auch nach Filtern/Nachladen)
   3. Englische Badge-Texte des Themes auf Deutsch (Sold out, New, Pre-order) – bis die Badge-Einstellungen im Theme deutsch sind
*/
(function () {
  'use strict';

  /* ---------- 1. Lieferzeitraum ---------- */
  var HOLIDAYS = ['2026-10-03', '2026-12-25', '2026-12-26', '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-01', '2027-05-06', '2027-05-17', '2027-10-03', '2027-12-25', '2027-12-26'];
  var DAY = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(d) { return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function workday(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(iso(d)) === -1; }
  function addWorkdays(d, n) { var x = new Date(d.getTime()), c = 0; while (c < n) { x.setUTCDate(x.getUTCDate() + 1); if (workday(x)) c++; } return x; }
  function fmt(d) { return DAY[d.getUTCDay()] + ', ' + pad(d.getUTCDate()) + '.' + pad(d.getUTCMonth() + 1) + '.'; }
  function berlinToday() {
    try {
      var o = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
      return new Date(Date.UTC(+o.year, +o.month - 1, +o.day));
    } catch (e) { return null; }
  }
  function delivery() {
    var els = document.querySelectorAll('[data-dc-dlv-date]');
    if (!els.length) return;
    var t = berlinToday();
    if (!t) return;
    var txt = 'Lieferung voraussichtlich ' + fmt(addWorkdays(t, 2)) + ' – ' + fmt(addWorkdays(t, 4));
    Array.prototype.forEach.call(els, function (el) { el.textContent = txt; });
  }

  /* ---------- 2. Ausverkauftes ans Ende ---------- */
  function isSoldOut(item) {
    var l = item.querySelector('[x-labels-data]');
    if (l) {
      var raw = l.getAttribute('x-labels-data') || '';
      if (/"available"\s*:\s*false/.test(raw) && !/"available"\s*:\s*true/.test(raw)) return true;
      if (/"available"\s*:\s*true/.test(raw)) return false;
    }
    return false;
  }
  function sortGrid(grid) {
    if (!grid || grid.getAttribute('data-dc-sorting') === '1') return;
    grid.setAttribute('data-dc-sorting', '1');
    var items = Array.prototype.filter.call(grid.children, function (c) { return c.classList.contains('grid-item') && c.querySelector('.card-product'); });
    var sold = items.filter(isSoldOut);
    var last = items[items.length - 1];
    if (sold.length && sold.length < items.length) {
      // nur verschieben, wenn hinter einem ausverkauften noch ein lieferbares steht
      var needs = false, seenSold = false;
      items.forEach(function (it) { if (isSoldOut(it)) seenSold = true; else if (seenSold) needs = true; });
      if (needs) {
        var anchor = last.nextSibling;
        sold.forEach(function (it) { grid.insertBefore(it, anchor); });
      }
    }
    sold.forEach(function (it) { it.setAttribute('data-dc-soldout', ''); });
    grid.removeAttribute('data-dc-sorting');
  }
  function initGrid() {
    var grid = document.getElementById('items-grid');
    if (!grid) return;
    sortGrid(grid);
    if ('MutationObserver' in window) {
      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { sortGrid(document.getElementById('items-grid')); }, 120);
      }).observe(grid.parentNode || grid, { childList: true, subtree: false });
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { sortGrid(document.getElementById('items-grid')); }, 120);
      }).observe(grid, { childList: true });
    }
  }

  /* ---------- 3. Badge-Texte ---------- */
  var MAP = { 'Sold out': 'Ausverkauft', 'Sold Out': 'Ausverkauft', 'New': 'Neu', 'Pre-order': 'Vorbestellbar', 'Pre-order now': 'Jetzt vorbestellen', 'Sale': 'Angebot' };
  function translateBadges(root) {
    var nodes = (root || document).querySelectorAll('.x-badge-text, .x-badge-content, [class*="x-badge-"] span');
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.children.length) return;
      var t = (el.textContent || '').trim();
      if (MAP[t]) el.textContent = MAP[t];
    });
  }
  function initBadges() {
    translateBadges(document);
    if (!('MutationObserver' in window)) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; translateBadges(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- 4. Feldbeschriftung im Benachrichtigungs-Formular ---------- */
  function fixLabels() {
    Array.prototype.forEach.call(document.querySelectorAll('.x-block-alert-back-stock label, .x-block-alert-back-stock input[placeholder]'), function (el) {
      if (el.tagName === 'INPUT') { if (/^Email/.test(el.placeholder)) el.placeholder = el.placeholder.replace(/^Email/, 'E-Mail'); return; }
      Array.prototype.forEach.call(el.childNodes, function (n) { if (n.nodeType === 3 && /\bEmail\b/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/\bEmail\b/, 'E-Mail'); });
    });
  }

  /* ---------- 5. Kategorie-Einleitung am Handy kürzen ---------- */
  function clampIntro() {
    var el = document.querySelector('.dc-plp-head__intro');
    if (!el || !window.matchMedia('(max-width: 749px)').matches) return;
    el.classList.add('is-clamped');
    if (el.scrollHeight <= el.clientHeight + 4) { el.classList.remove('is-clamped'); return; }
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'dc-more-btn'; b.textContent = 'Weiterlesen'; b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function () {
      var open = el.classList.toggle('is-clamped') === false;
      b.textContent = open ? 'Weniger anzeigen' : 'Weiterlesen';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    el.parentNode.insertBefore(b, el.nextSibling);
  }

  function init() { delivery(); initGrid(); initBadges(); fixLabels(); clampIntro(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
